/**
 * GameRecoveryController
 *
 */
(function () {
  class GameRecoveryController {
    constructor() {
      this._task = undefined;
      this._commandsToSend = [];
    }

    initialise() {
      messageBus.subscribe(
        "common:RecoverGameListener",
        this.onRecoverGameListener.bind(this)
      );
    }

    onHandledCommand() {
      this._commandsToSend.shift();
      if (this._commandsToSend.length === 0) {
        this._task.leave();
        this._task = undefined;
      }
    }

    onWaitForInput() {}

    setupRecoveryGame(task) {
      this._task = task;
      this._task.join();

      this._commandsToSend = JSON.parse(
        JSON.stringify(this._task.data.previousCommands.slice(1))
      ); // ignore Base command
    }

    onRecoverGameListener(task) {
      // are their commands here that took us to the gamble game?
      let commands = task.data.previousCommands;

      for (let i = 0; i < commands.length; ++i) {
        //if (commands[i].indexOf("GAMBLE") !== -1) {

        if (commands[i].indexOf("COLLECT") !== -1) {
          this.setupRecoveryGame(task);
          break;
        }
      }
    }
  }

  resourceManager.registerController("GameRecoveryController", function () {
    return new GameRecoveryController();
  });
})();
